import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { usePageMeta } from "@/hooks/usePageMeta";
import Hero from "./components/Hero";
import TopRanking from "./components/TopRanking";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedSection from "./components/FeaturedSection";
import ArticlePreview from "./components/ArticlePreview";
import FaqPreview from "./components/FaqPreview";

export default function Home() {
  usePageMeta({
    title: "漫画软件应用排行推荐大全 - 哪个好用一网打尽",
    description:
      "漫画软件应用哪个好？这里整理漫画软件应用排行与热门推荐，收录漫画软件应用大全与合集，帮你快速锁定好用的漫画软件应用，解决找漫画、追更、看热门作品的需求。",
    canonical: "https://mangao0.github.io/",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "漫画软件应用排行推荐大全",
      description: "漫画软件应用排行、推荐与大全合集平台",
      url: "https://mangao0.github.io/",
    },
  });

  return (
    <Layout title="首页">
      <Hero />
      <TopRanking />
      <CategoryGrid />
      <FeaturedSection />

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
          <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
                <i className="ri-team-fill" aria-hidden="true"></i>
                关于漫选社
              </span>
              <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">一群爱看漫画的人，认真帮你选应用</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">
                我们是一群重度漫画读者，也踩过不少找应用的坑。漫选社坚持从真实阅读体验出发，逐款上手评测主流的漫画软件应用，整理成清晰易读的排行与推荐，帮同样爱看漫画的你节省挑选时间。
              </p>
              <ul className="mt-5 space-y-3 text-sm text-foreground-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" aria-hidden="true"></i>
                  真实上手，逐款评测主流漫画软件应用
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" aria-hidden="true"></i>
                  榜单与推荐定期更新，紧跟追更潮流
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" aria-hidden="true"></i>
                  内容客观实用，帮你花最少时间选对工具
                </li>
              </ul>
              <Link
                to="/about"
                className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                了解我们
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: "ri-heart-3-fill", num: "9+", label: "精选应用" },
                { icon: "ri-article-fill", num: "6", label: "深度评测" },
                { icon: "ri-dashboard-fill", num: "6类", label: "内容分类" },
                { icon: "ri-star-smile-fill", num: "4.8", label: "平均评分" },
              ].map((s) => (
                <div key={s.label} className="rounded-2xl border border-background-200/80 bg-background-50 p-6 text-center transition-colors hover:border-primary-300">
                  <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                    <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <p className="mt-3 font-heading text-3xl text-foreground-950">{s.num}</p>
                  <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <ArticlePreview />
      <FaqPreview />
    </Layout>
  );
}